import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2HandIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 26 27",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    children: /*#__PURE__*/jsx("path", {
      vectorEffect: "non-scaling-stroke",
      d: "M13 19c0-4.5-3.978-3.462-3.978-3.462L7.5 11.5C7 10.5 6 10 5 10.5s-.746 1.336-.5 2.176L6 18.204v.036C7 22 9.066 26 14 26c3.931 0 7.209-4.5 7.209-9.324l-.018.026L22.5 8.917c0-.738-.5-1.5-.81-1.5-.308 0-1.19 0-1.748 1l-1.773 5.636-.036-1.022.655-4.114.654-4.115c0-.737-.684-1.333-1.511-1.333-.836 0-1.511.604-1.511 1.333l-1.31 8.22V3c0-.738-.684-1.333-1.51-1.333-.836 0-1.511.604-1.511 1.333v9.676l-1.078-8.01c0-.737-.685-1.333-1.511-1.333-.836 0-1.511.605-1.511 1.334l1.077 9.59"
    })
  });
};

export { PM2HandIcon };
//# sourceMappingURL=hand.js.map
